// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hYKcLp3eO2RFnzS9Tgt4 .nav.nav-tabs {
  border-color: #e3e3e3;
  align-items: end;
}
.hYKcLp3eO2RFnzS9Tgt4 .nav.nav-tabs .nav-item > .nav-link:not(.active) {
  font-size: 14px;
  line-height: 16px;
  padding: 14px 20px;
  box-shadow: 2px -1px 5px 0 rgba(0, 0, 0, 0.1);
}
.hYKcLp3eO2RFnzS9Tgt4 .nav.nav-tabs .nav-item > .nav-link.active {
  font-size: 16px;
  line-height: 19px;
  padding: 16px 20px;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/modules/network/ThreatIntel/container.module.scss"],"names":[],"mappings":"AAEI;EACI,qBAAA;EACA,gBAAA;AADR;AAGQ;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,6CAAA;AADZ;AAIQ;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;AAFZ","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n.threat-intel-report {\n    :global(.nav.nav-tabs) {\n        border-color: #e3e3e3;\n        align-items: end;\n\n        :global(.nav-item > .nav-link:not(.active)) {\n            font-size: 14px;\n            line-height: 16px;\n            padding: 14px 20px;\n            box-shadow: 2px -1px 5px 0 rgba(0, 0, 0, 0.1);\n        }\n\n        :global(.nav-item > .nav-link.active) {\n            font-size: 16px;\n            line-height: 19px;\n            padding: 16px 20px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"threat-intel-report": `hYKcLp3eO2RFnzS9Tgt4`
};
export default ___CSS_LOADER_EXPORT___;
